<template>
  <div>
    <b-row>
      <b-col md="4">
        <b-card class="border border-dark shadow-none">
          <div>
            <b-row>
              <b-col class="align-self-end">
                <h4 class="font-weight-bolder">
                  Datos del cliente
                </h4>
              </b-col>
              <b-button
                :variant="visible ? 'flat-primary' : 'flat-secondary'"
                class="btn-icon rounded-circle mr-1"
                @click="collapse"
              >
                <feather-icon :icon="iconToggle" />
              </b-button>

            </b-row>
          </div>

          <b-collapse
            :id="collapseItemId"
            v-model="visible"
            role="tabpanel"
          >
            <div>
              <hr>
              <h4 class="font-weight-bolder">
                {{ `${customerInfo.Name} ${customerInfo.LastName || ''}` }}
              </h4>
            </div>
            <div class="text-primary">
              {{ customerInfo.email }}
            </div>
            <div>
              {{ customerInfo.Phone }}
            </div>
            <InformationBasicCard
              v-if="customerInfo.BusinessName"
              title="Razón social"
              :tags="[{ value:customerInfo.BusinessName, type: 'string' }]"
            />
          </b-collapse>
        </b-card>
      </b-col>
      <b-col md="4">
        <ShipmentAddress
          :quote="quote"
          :show-toggle-button="true"
          :show-use-other-button="false"
        />
      </b-col>
      <b-col md="4">
        <InvoiceAddress
          :quote="quote"
          :show-toggle-button="true"
          :show-use-other-button="false"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BCard, BButton, BCollapse,
} from 'bootstrap-vue'

import InformationBasicCard from '@/components/cards/InformationBasicCard.vue'
import InvoiceAddress from '@/modules/trade/quotes/components/form/InvoiceAddress.vue'
import ShipmentAddress from '@/modules/trade/quotes/components/form/ShipmentAddress.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    BCollapse,
    InvoiceAddress,
    ShipmentAddress,
    InformationBasicCard,
  },
  props: {
    quote: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      visible: false,
      collapseItemId: '5',
      iconToggle: 'ChevronDownIcon',
      customerInfo: null,
    }
  },
  created() {
    const [customerInfo] = this.quote.client
    this.customerInfo = customerInfo
  },
  methods: {
    collapse() {
      this.$root.$emit('bv::toggle::collapse', this.collapseItemId)
      this.visible = !this.visible
      this.setToggleIcon()
    },
    setToggleIcon() {
      this.iconToggle = this.visible ? 'ChevronUpIcon' : 'ChevronDownIcon'
    },
  },
}
</script>
